/* HILO · Homepage behaviour — sections/hilo-home-*.liquid
   Rails and sliders scroll natively (CSS scroll-snap). This file adds the
   arrow buttons, slider dots, hero autoplay, reel playback and the active
   story step. Runs per section, and again when the theme editor reloads one.
   Hooks: [data-hh-rail] (root) > [data-hh-track], [data-hh-prev],
   [data-hh-next], [data-hh-dot]; [data-hh-loop]; [data-hh-autoplay="6"];
   [data-hh-video] > video + [data-hh-play]; [data-hh-steps] > .hh-step */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function rail(root) {
    var track = root.querySelector('[data-hh-track]');
    if (!track || track.hhReady) return;
    track.hhReady = true;
    var loop = root.hasAttribute('data-hh-loop');
    var prev = root.querySelectorAll('[data-hh-prev]');
    var next = root.querySelectorAll('[data-hh-next]');
    var dots = root.querySelectorAll('[data-hh-dot]');
    var timer = 0;
    var hold = false;

    function size() {
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap) || 0;
      var first = track.firstElementChild;
      var unit = (first ? first.getBoundingClientRect().width + gap : track.clientWidth) || 1;
      var view = track.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
      return { unit: unit, per: Math.max(1, Math.floor((view + gap + 2) / unit)) };
    }
    function current() { return Math.round(track.scrollLeft / size().unit); }
    function end() { return track.scrollWidth - track.clientWidth - 2; }
    function go(i) {
      var n = track.children.length;
      i = loop ? (i + n) % n : Math.max(0, Math.min(i, n - 1));
      track.scrollTo({ left: i * size().unit, behavior: reduce ? 'auto' : 'smooth' });
    }
    function move(dir) {
      if (loop && dir > 0 && track.scrollLeft >= end()) { go(0); return; }
      if (loop && dir < 0 && track.scrollLeft <= 2) { go(track.children.length - 1); return; }
      go(current() + dir * size().per);
    }
    function stop() { if (timer) { clearInterval(timer); timer = 0; } }
    function sync() {
      var i = current();
      each(dots, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (!loop) {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= end();
        each(prev, function (b) { b.disabled = atStart; });
        each(next, function (b) { b.disabled = atEnd; });
      }
      if (track.scrollWidth <= track.clientWidth + 2) root.setAttribute('data-hh-static', '');
      else root.removeAttribute('data-hh-static');
    }

    each(prev, function (b) { b.addEventListener('click', function () { stop(); move(-1); }); });
    each(next, function (b) { b.addEventListener('click', function () { stop(); move(1); }); });
    each(dots, function (d, k) { d.addEventListener('click', function () { stop(); go(k); }); });
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; sync(); });
    }, { passive: true });
    window.addEventListener('resize', sync);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    sync();

    var secs = parseFloat(root.getAttribute('data-hh-autoplay')) || 0;
    if (secs > 0 && !reduce && track.children.length > 1) {
      timer = setInterval(function () { if (!hold && !document.hidden) move(1); }, secs * 1000);
      root.addEventListener('mouseenter', function () { hold = true; });
      root.addEventListener('mouseleave', function () { hold = false; });
      root.addEventListener('focusin', function () { hold = true; });
      root.addEventListener('focusout', function () { hold = false; });
      track.addEventListener('touchstart', stop, { passive: true });
    }
  }

  /* Reels and the weaver collage: a tile's video plays in place when its
     play mark is tapped; one video plays at a time.
     The play mark follows the video itself — hidden while it plays, back
     when it is paused (including from the video's own controls) or ends —
     so the mark never sits over a playing video or blocks its controls.
     Set inline because `.hh .hh-reel__play` (display: grid) in
     hilo-home.css outranks the `.is-playing > .hh-reel__play` rule.
     If the browser refuses to play with sound, it retries muted; a play
     that was interrupted by a pause is left paused.
     A playing reel pauses once it is swiped or scrolled mostly out of view. */
  var offscreen = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting && !e.target.paused) e.target.pause();
    });
  }, { threshold: 0.25 }) : null;

  function reels(scope) {
    each(scope.querySelectorAll('[data-hh-play]'), function (btn) {
      if (btn.hhReady) return;
      btn.hhReady = true;
      var tile = btn.closest('[data-hh-video]');
      var video = tile && tile.querySelector('video');
      if (!video) return;
      function mark(show) { btn.style.display = show ? '' : 'none'; }
      video.addEventListener('play', function () { tile.classList.add('is-playing'); mark(false); });
      video.addEventListener('pause', function () { mark(true); });
      video.addEventListener('ended', function () { mark(true); });
      if (offscreen) offscreen.observe(video);
      btn.addEventListener('click', function () {
        each(document.querySelectorAll('[data-hh-video] video'), function (v) { if (v !== video && !v.paused) v.pause(); });
        tile.classList.add('is-playing');
        video.controls = true;
        var p = video.play();
        if (p && p.catch) p.catch(function (err) {
          if (!err || err.name !== 'NotAllowedError') { if (video.paused) mark(true); return; }
          video.muted = true;
          var q = video.play();
          if (q && q.catch) q.catch(function () { mark(true); });
        });
      });
    });
  }

  function steps(scope) {
    if (!('IntersectionObserver' in window)) return;
    each(scope.querySelectorAll('[data-hh-steps]'), function (list) {
      if (list.hhReady) return;
      list.hhReady = true;
      var items = list.querySelectorAll('.hh-step');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) each(items, function (s) { s.classList.toggle('is-active', s === e.target); });
        });
      }, { rootMargin: '-40% 0px -40% 0px' });
      each(items, function (s) { io.observe(s); });
    });
  }

  function init(scope) {
    scope = scope || document;
    if (scope.matches && scope.matches('[data-hh-rail]')) rail(scope);
    each(scope.querySelectorAll('[data-hh-rail]'), rail);
    reels(scope);
    steps(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
